/**
 * Enums describing the various timings for calls to a particular trackLayerDecision hook.
 * See https://confluence.sso.episerver.net/display/EXPENG/Design+Doc%3A+improved+redirect+tracking
 * @module
 */

var keyMirror = require('keymirror');

/**
 * The timing of an invocation of a trackLayerDecision hook - before or after the redirect (for redirect decision
 * tracking) or neither (for tracking of all other decisions).
 * @enum
 */
exports.TrackLayerDecisionTimingFlags = keyMirror({
  preRedirectPolicy: null,
  postRedirectPolicy: null,
  nonRedirectPolicy: null,
});

/**
 * Whether we should call the tracker, persist data to the Redirect Relay Medium, etc.
 * after deciding to perform a redirect.
 * @enum
 */
exports.PreRedirectPolicies = keyMirror({
  PERSIST_BEFORE_AND_TRACK_DURING_REDIRECT: null,
  PERSIST_BEFORE_REDIRECT: null,
});

/**
 * When we should call the tracker if we believe the visitor loaded this page thanks to a redirect.
 * @enum
 */
exports.PostRedirectPolicies = keyMirror({
  TRACK_IMMEDIATELY: null,
  TRACK_AFTER_SYNC: null,
});

/**
 * When we should call the tracker after making a decision that does not require us to perform a redirect.
 * @enum
 */
exports.NonRedirectPolicies = keyMirror({
  TRACK_IMMEDIATELY: null,
});

/**
 * Supported values for the __DEFAULT_REDIRECT_RELAY_MEDIUM__ define and supported keys for the __REDIRECT_RELAY_MEDIA__
 * define.
 * @enum
 */
exports.RedirectRelayMedia = keyMirror({
  COOKIE: null,
});
